const training_es = require('./training.json')
export default training_es